import gql from 'graphql-tag'

export const GET_REPORT = gql`
  query GetReportInvoicing(
    $id_client: ID
    $id_site: ID
    $id_machine_type: ID
    $id_machine: ID
    $from: String!
    $to: String!
    $uf_value: String
  ) {
    reportInvoicing(
      id_client: $id_client
      id_site: $id_site
      id_machine_type: $id_machine_type
      id_machine: $id_machine
      from: $from
      to: $to
      uf_value: $uf_value
    )
  }
`

export const GET_EXCEL = gql`
  query GetReportInvoicingExcel(
    $id_client: ID
    $id_site: ID
    $id_machine_type: ID
    $id_machine: ID
    $from: String!
    $to: String!
    $uf_value: String
  ) {
    reportInvoicingExcel(
      id_client: $id_client
      id_site: $id_site
      id_machine_type: $id_machine_type
      id_machine: $id_machine
      from: $from
      to: $to
      uf_value: $uf_value
    )
  }
`
